export type Language = 'en' | 'cn';

export const translations = {
  en: {
    appTitle: "GM Project Filter",
    home: "Home",
    dashboard: "Dashboard",
    crAnalysis: "CR Analysis",
    radarPlot: "Radar Compare",
    strategyFunnel: "Strategy Funnel",
    newScore: "New Score",
    projects: "Projects",
    totalProjects: "Total Projects",
    strategicWins: "Strategic Wins",
    avgScore: "Avg RCC5 Score",
    quickAction: "Quick Action",
    newProjectBtn: "+ New Project",
    stratMatrix: "Strategic Matrix (RCC5 vs FT1P)",
    crMatrixTitle: "CR Matrix: Competitive Reality",
    recentProjects: "Recent Projects",
    scoringAssessment: "Scoring Assessment",
    currentStatus: "Current Status",
    basicInfo: "Basic Information",
    customerName: "Customer Name",
    projectName: "Project Name",
    region: "Region",
    rcc5Title: "RCC5: Right Customer",
    ft1pTitle: "FT1P: Right Product",
    tcoTitle: "TCO: Engineering Load",
    dpcTitle: "DPC: Access & Power",
    dpc2Title: "DPC²: Engineering Influence",
    dpc3Title: "DPC³: Risk Management",
    saveProject: "Save Project",
    editProject: "Edit Project",
    saveChanges: "Save Changes",
    cancelEdit: "Cancel",
    editButton: "Edit",
    deleteButton: "Delete",
    projectDb: "Project Database",
    exportCsv: "Export CSV",
    colProject: "Project",
    colCustomer: "Customer",
    colRegion: "Region",
    colQuadrant: "Quadrant",
    colCR: "CR Zone",
    colActions: "Actions",
    noProjects: "No projects found.",
    deleteConfirm: "Delete project?",
    alertEnterFields: "Enter Name",
    radarSubtitle: "Comprehensive Analysis",
    overallRadar: "Overall Strategic Profile (Normalized)",
    selectProjects: "Select Projects to Compare:",
    q1: "Zone 1: Strategic Apex",
    q2: "Zone 2: Strategic Growth",
    q3: "Zone 3: Relationship Maintenance",
    q4: "Zone 4: Tactical Breakthrough",
    q5: "Zone 5: Cautious Screening",
    q6: "Zone 6: Cautious Entry",
    q7: "Zone 7: Profit Temptation",
    q8: "Zone 8: Resource Black Hole",
    q9: "Zone 9: Strategic Forbidden Zone",
    axisX: "RCC5 (Customer)",
    axisY: "FT1P (Product)",
    crAxisX: "Non-Core <---> Core",
    crAxisY: "High Dependency <---> Low",
    statusPriority: "STRATEGIC",
    statusEval: "EVALUATING...",
    rcc5_r: "Relevance",
    rcc5_c1: "Core Pos",
    rcc5_c2: "Culture",
    rcc5_a: "Access",
    rcc5_s: "Scale",
    ft1p_p: "Product Core",
    ft1p_d: "Design Infl",
    ft1p_t: "Tech Fit",
    ft1p_c: "Competitiveness",
    ft1p_l: "Leadership",
    tco_d: "Dev Load",
    tco_t: "Trial Load",
    tco_m: "Mass Prod Load",
    dpc_1: "Access Key",
    dpc_2: "Infl Judg",
    dpc_3: "Advice",
    dpc_4: "Consistency",
    dpc_5: "Solution",
    dpc2_1: "DFM",
    dpc2_2: "Struct",
    dpc2_3: "Mat/Proc",
    dpc2_4: "Cosmetic",
    dpc2_5: "DQE",
    dpc3_1: "KRI",
    dpc3_2: "Risk Acc",
    dpc3_3: "Proc Win",
    dpc3_4: "Insp Cost",
    dpc3_5: "Auto",
    cr6Title: "CR6 Quadrant (Competitor Analysis)",
    cr6_competitor_core: "Is Competitor's Product Core to Customer?",
    cr6_competitor_core_sub: "1=Non-Core product for customer, 5=Core product for customer",
    cr6_competitor_dependency: "Competitor's Dependency on Customer",
    cr6_competitor_dependency_sub: "1=Low dependency, 5=High dependency",
    advice_title: "Strategic Advice",
    cr_a1: "A1: Golden Window",
    cr_a2: "A2: Minefield",
    cr_b1: "B1: Attack/Defend",
    cr_b2: "B2: No Future",
    cr_c1: "C1: Entry Zone",
    cr_c2: "C2: Caution Zone",
    cr_dynamic: "Dynamic Zone",
    // CR六象限完整标签
    cr_b2_label: "B2: No Future",
    cr_a2_label: "A2: Minefield",
    cr_c2_label: "C2: Caution",
    cr_b1_label: "B1: Attack/Defend",
    cr_c1_label: "C1: Entry",
    cr_a1_label: "A1: Golden Window",
    // 雷达图相关
    radarModeClear: "Clear Mode (Max 3)",
    radarModeDetailed: "Detailed Mode (Max 5)",
    radarMaxReached: "Maximum number of projects reached",
    radarWarning: "Adding more projects may affect readability",
    radarMaxLimit: "Max Limit",
    radarMaxProjects: "Max Projects",
    radarCurrentSelection: "Current",
    radarMaxLimitDescription: "Maximum allowed projects (1-50)",
    radarSelectByCustomer: "Select by Customer",
    radarCustomerProjects: "projects",
    radarSelectAllCustomers: "Select All",
    radarDeselectAllCustomers: "Deselect All",
    radarExpandCustomer: "Expand",
    radarCollapseCustomer: "Collapse",
    selectProjectsToDisplay: "Select Projects to Display",
    showAllProjects: "Show All",
    itemsPerPage: "Items per page",
    page: "Page",
    of: "of",
    previousPage: "Previous",
    nextPage: "Next",
    total: "Total",
  },
  cn: {
    appTitle: "GM 项目筛选系统",
    home: "首页",
    dashboard: "仪表盘",
    crAnalysis: "CR 六象限",
    radarPlot: "六维雷达对比",
    strategyFunnel: "战略漏斗",
    newScore: "新建评分",
    projects: "项目列表",
    totalProjects: "项目总数",
    strategicWins: "战略赢单",
    avgScore: "平均 RCC5",
    quickAction: "快速操作",
    newProjectBtn: "+ 新建项目",
    stratMatrix: "战略矩阵 (RCC5 vs FT1P)",
    crMatrixTitle: "CR 竞争现实矩阵 (能否赢)",
    recentProjects: "近期项目",
    scoringAssessment: "评分评估",
    currentStatus: "当前状态",
    basicInfo: "基本信息",
    customerName: "客户名称",
    projectName: "项目名称",
    region: "区域",
    rcc5Title: "RCC5: 选对客户",
    ft1pTitle: "FT1P: 选对产品",
    tcoTitle: "TCO: 工程负荷",
    dpcTitle: "DPC (关键人与决策力)",
    dpc2Title: "DPC² (工程影响力)",
    dpc3Title: "DPC³ (风险管理力)",
    saveProject: "保存项目",
    editProject: "编辑项目",
    saveChanges: "保存更改",
    cancelEdit: "取消",
    editButton: "编辑",
    deleteButton: "删除",
    projectDb: "项目数据库",
    exportCsv: "导出 CSV",
    colProject: "项目",
    colCustomer: "客户",
    colRegion: "区域",
    colQuadrant: "战略象限",
    colCR: "CR 区域",
    colActions: "操作",
    noProjects: "暂无数据",
    deleteConfirm: "确认删除?",
    alertEnterFields: "请输入名称",
    radarSubtitle: "多维度项目能力对比",
    overallRadar: "综合战略画像 (归一化)",
    selectProjects: "选择对比项目:",
    q1: "Zone 1: 战略巅峰区",
    q2: "Zone 2: 战略培育区",
    q3: "Zone 3: 关系维护区",
    q4: "Zone 4: 战术突破区",
    q5: "Zone 5: 稳健筛选区",
    q6: "Zone 6: 谨慎准入区",
    q7: "Zone 7: 利润诱惑区",
    q8: "Zone 8: 资源黑洞区",
    q9: "Zone 9: 战略禁区",
    axisX: "RCC5 (客户)",
    axisY: "FT1P (产品)",
    crAxisX: "非核心 <---> 核心产品",
    crAxisY: "高依存 <---> 低依存 (对手)",
    statusPriority: "战略重点",
    statusEval: "评估中...",
    rcc5_r: "行业相关性",
    rcc5_c1: "行业领导地位",
    rcc5_c2: "供应链文化/开放度",
    rcc5_a: "接触/影响关键人能力",
    rcc5_s: "规模与复利价值",
    ft1p_p: "核心产品程度",
    ft1p_d: "设计影响力",
    ft1p_t: "技术适配",
    ft1p_c: "可竞争性",
    ft1p_l: "客户项目团队成熟度",
    tco_d: "开发负荷",
    tco_t: "试模负荷",
    tco_m: "量产负荷",
    dpc_1: "能否接触关键人",
    dpc_2: "能否影响关键人",
    dpc_3: "客户是否接受专业意见",
    dpc_4: "客户内部决策效率",
    dpc_5: "我们是否是解决方案提供者",
    dpc2_1: "DFM影响力",
    dpc2_2: "结构设计影响力",
    dpc2_3: "材料与工艺窗口影响力",
    dpc2_4: "外观等级影响力",
    dpc2_5: "DQE影响力",
    dpc3_1: "关键风险识别能力 KRI",
    dpc3_2: "客户风险接受度影响力",
    dpc3_3: "工艺窗口管理能力",
    dpc3_4: "QC 负荷管理",
    dpc3_5: "自动化潜力/适配",
    cr6Title: "CR6六象限 (竞争对手分析)",
    cr6_competitor_core: "对手的产品对客户是否核心?",
    cr6_competitor_core_sub: "1=非核心产品, 5=核心产品",
    cr6_competitor_dependency: "对手对这个客户的依存度",
    cr6_competitor_dependency_sub: "1=低依存, 5=高依存",
    advice_title: "智能战略建议",
    cr_a1: "A1: 黄金窗口",
    cr_a2: "A2: 黄金地雷",
    cr_b1: "B1: 可攻可守",
    cr_b2: "B2: 无未来区",
    cr_c1: "C1: 入口区",
    cr_c2: "C2: 谨慎区",
    cr_dynamic: "动态区",
    // CR六象限完整标签
    cr_b2_label: "B2: 无未来",
    cr_a2_label: "A2: 黄金地雷",
    cr_c2_label: "C2: 谨慎",
    cr_b1_label: "B1: 可攻可守",
    cr_c1_label: "C1: 入口",
    cr_a1_label: "A1: 黄金窗口",
    // 雷达图相关
    radarModeClear: "清晰模式 (最多3个)",
    radarModeDetailed: "详细模式 (最多5个)",
    radarMaxReached: "已达到最大对比数量",
    radarWarning: "添加更多项目可能影响可读性",
    radarMaxLimit: "最大上限",
    radarMaxProjects: "最大项目数",
    radarCurrentSelection: "当前选择",
    radarMaxLimitDescription: "允许的最大项目数上限（1-50）",
    radarSelectByCustomer: "按客户选择",
    radarCustomerProjects: "个项目",
    radarSelectAllCustomers: "全选",
    radarDeselectAllCustomers: "全不选",
    radarExpandCustomer: "展开",
    radarCollapseCustomer: "折叠",
    selectProjectsToDisplay: "选择要显示的项目",
    showAllProjects: "显示全部",
    itemsPerPage: "每页显示",
    page: "页",
    of: "共",
    previousPage: "上一页",
    nextPage: "下一页",
    total: "共",
  },
} as const;

export type Translations = typeof translations.en;

